import React from 'react';
import type { ComponentProps } from 'react';
import styled from '@emotion/styled';
import type { FlexProps, FontSizeProps } from 'styled-system';
import { flex, fontSize } from 'styled-system';

import type { ThemedButtonWithHTMLAttrs } from '../Button';
import { Button } from '../Button';

type ProceedButtonProps = FontSizeProps & FlexProps;

const UnstyledProceedButton: ThemedButtonWithHTMLAttrs<ProceedButtonProps> = styled(Button)`
  ${fontSize};
  ${flex};
`;

const ProceedButton = (props: ComponentProps<typeof UnstyledProceedButton>) => (
  <UnstyledProceedButton fontSize="fs_16" flex={1} {...props} />
);

export default ProceedButton;
